import { FieldInputProps, useField } from 'formik';
import React from 'react';

import { WLFormErrorMessage, WLFormField } from '../../design-library';
import { FormFieldVariant } from '../../design-library/Forms/FormField/FormField';
import { HelperTextPosition } from '../../design-library/Forms/FormField/FormField';

interface FormikFieldAdapterProps {
  name: string;
  label?: string;
  helperText?: string;
  helperTextPosition?: HelperTextPosition;
  isFieldSet?: boolean;
  required?: boolean;
  showRequiredLabel?: boolean;
  renderField: (adapterProps: FieldInputProps<any>) => React.ReactElement;
  hideLabel?: boolean;
  variant?: FormFieldVariant;
}

const FormikFieldAdapter: React.FC<FormikFieldAdapterProps> = ({
  name,
  label,
  helperText,
  helperTextPosition,
  isFieldSet,
  hideLabel,
  required,
  showRequiredLabel,
  renderField,
  variant,
}) => {
  const [field, meta] = useField(name);
  return (
    <WLFormField
      name={name}
      isFieldSet={isFieldSet}
      label={label}
      helperText={helperText}
      helperTextPosition={helperTextPosition}
      isInvalid={meta.touched && !!meta.error}
      required={required}
      showRequiredLabel={showRequiredLabel}
      hideLabel={hideLabel}
      variant={variant}
    >
      {renderField(field)}
      <WLFormErrorMessage>{meta.error}</WLFormErrorMessage>
    </WLFormField>
  );
};

export default FormikFieldAdapter;
